export default __webpack_public_path__ + "static/media/N2P_1906.677aed4d.jpg";